{
  "version": 1,
  "asset_id": "8de08b8d-0534-46e5-8f63-0dc1ae9e1ecd",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8de08b8d-0534-46e5-8f63-0dc1ae9e1ecd/hiatal-type-1-repair-en-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8de08b8d-0534-46e5-8f63-0dc1ae9e1ecd/hiatal-type-1-repair-en-800.webp",
  "original_filename": "hiatal-type-1-repair-en-800.webp",
  "size": 41418,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:54:47Z"
}
